import React, { useEffect } from 'react';
//import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import L from "leaflet";
import logoLoader from '../extra/camera-small.png'

const AlwaysOpenPopup = ({ position, desc }) => {
  // const map = useMap();
  return null;
};

const Map = ({ height, markers }) => {
  if (!markers || !markers.length) return null;
  const position = markers[0].latlng;
  height = height || "100vh";


  return (<>

  </>);
};

export default Map;